import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { PopupData, Service } from 'webapp-types';

import FormSelectWithPopupAsDropdownComponent from 'webapp/components/form/select-with-popup-as-dropdown';
import GoalsMeasurementPopupComponent from 'webapp/components/goals/measurement/popup';

import type { Goal } from 'webapp/models-custom';

interface Args {
	model: Goal;
}

export default class GoalsMeasurementDropdownComponent extends Component<Args> {
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	get model() {
		return this.args.model;
	}

	get options() {
		// only currently selected can be shown bcos we handle list though popup
		const selected = this.model.measurement;
		const selectedOption = this.mmGoalsService.measurementOptions.find(
			(o) => o.value === selected,
		);

		if (selectedOption) {
			// remove label2
			return [
				{
					label: selectedOption?.label,
					value: selected!,
				},
			];
		} else {
			return [];
		}
	}

	@action
	changeMeasurement(value: string) {
		this.model.measurement = value;
	}

	@action
	doNothing() {
		// changes on this dropdown will go through the popup
		// since the dropdown cannot even be opened
	}

	// ------ for popup ----- //

	popupComponent = GoalsMeasurementPopupComponent;

	popupClass = 'optionspopup popup-type-goal-measurement';

	@action
	getPopupProps() {
		const props: PopupData.Goal.Measurement = {
			model: this.model,
		};

		return props;
	}
	<template>
		<FormSelectWithPopupAsDropdownComponent
			@selected={{this.model.measurement}}
			@options={{this.options}}
			@onChange={{this.doNothing}}
			@isNumeric={{false}}
			@popupOffset={{-12}}
			@popupComponent={{this.popupComponent}}
			@popupClass={{this.popupClass}}
			@getPopupProps={{this.getPopupProps}}
		/>
	</template>
}
